import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContainer, fromMd } from '../Util';
import Constant from '../Constant';

export default function Terms(props) {
  const {
    APP_NAME: name,
    LINK: link,
    EMAIL: email,
    COUNTRY: country,
  } = Constant;

  const { t } = useTranslation();
  const md = t(`terms`, { name, link, email, country });

  return (
    <PageContainer
      title={t('Terms & Conditions')}
      className="p-5 bg-white text-dark rounded shadow-lg"
    >
      <div dangerouslySetInnerHTML={fromMd(md)} />
    </PageContainer>
  );
}
